// extracted by mini-css-extract-plugin
export default {"cardPhotoMain":"jEnBueMd","mobile":"BeJoqn7i","link":"e26sCdZQ","info":"JcfX7eYY","headline":"pxBHmSl9","date":"znr0ORaK","type":"vmKMud0c"};